import { StickyNote, Bell } from 'lucide-react';

// Coming-soon: stickies + reminders. Self-contained, looks finished,
// hot-swaps to live data when the endpoints ship.

export const OnYourMind = () => (
  <section
    aria-label="On your mind"
    aria-disabled="true"
    className="relative rounded-2xl border border-dashed border-line bg-bg-secondary/50 p-4 shadow-sm sm:p-5"
  >
    <div className="mb-3 flex items-center justify-between">
      <h2 className="text-sm font-semibold tracking-tight text-text-secondary">On your mind</h2>
      <span className="coming-soon-pulse rounded-full bg-brand-orange/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-brand-orange">
        Coming soon
      </span>
    </div>

    <div className="space-y-3 opacity-60">
      <div className="rounded-lg border border-dashed border-line bg-bg-primary/40 p-3">
        <div className="mb-1.5 flex items-center gap-2 text-text-tertiary">
          <StickyNote className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="text-[11px] font-semibold uppercase tracking-wider">Sticky notes</span>
        </div>
        <p className="text-xs text-text-tertiary">
          Jot quick reminders right here. Auto-syncs across your devices.
        </p>
      </div>

      <div className="rounded-lg border border-dashed border-line bg-bg-primary/40 p-3">
        <div className="mb-1.5 flex items-center gap-2 text-text-tertiary">
          <Bell className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="text-[11px] font-semibold uppercase tracking-wider">Reminders</span>
        </div>
        <p className="text-xs text-text-tertiary">
          Schedule a nudge — for a callback, a deadline, a meeting prep window.
        </p>
      </div>
    </div>
  </section>
);
